import axios from '@/libs/api.request';

export const HrUserSave = data => {
    return axios.request({
        url: 'api/accountManagement/HrUserManagement/HrUserSave',
        data: data,
        method: 'post'
    });
};

export const getHrUserDetail = userHrLoginUuid => {
    return axios.request({
        url: 'api/accountManagement/HrUserManagement/getHrUserDetail',
        data: { userHrLoginUuid },
        method: 'post'
    });
};

export const getHrUserList = data => {
    return axios.request({
        url: 'api/accountManagement/HrUserManagement/getHrUserList',
        data: data,
        method: 'post'
    });
};
